import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Data Component
 */
let CompanyDataComponent = class CompanyDataComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.userData = {};
        this.companyData = {};
        this.notifications = {};
        this.updateNotifications = {};
        this.changed = false;
        this.isCompany = false;
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.accentColor = '';
        this.backColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
        });
    }
    ngOnInit() {
        localStorage.removeItem('draftData');
        this.httpClient.get('user/data').subscribe((data) => {
            this.userData = data;
            this.companyData = this.userData.company;
            this.userData.password = 'necesmajci';
            if (this.userData.ispep === 0) {
                this.isPep = true;
            }
            else {
                this.isPep = false;
            }
        });
    }
};
CompanyDataComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
CompanyDataComponent = __decorate([
    Component({
        selector: 'ecd-company-data',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./company-data.component.html")).default
    })
], CompanyDataComponent);
export { CompanyDataComponent };
